import AppSidebar from "../../../../../components/Sidebar/AppSidebar";

const LeftSideBarComponent = () => <AppSidebar />;

export default LeftSideBarComponent;
